import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const ExternalLink = styled.a<IWithSize>`
  & {
    color: black;
    text-decoration: none;
  }
  & > li {
    border: 1px solid transparent;
    padding-left: ${({ size }) => (size ? 2.9 * size : 2.9)}em;
    font-size: ${({ size }) => (size ? 14 * size : 14)}px;
    display: flex;
    justify-content: space-between;
    padding-right: ${({ size }) => (size ? size : 1)}em;
    color: #3e3e3e;
    width: 240px;
  }
`

export default ExternalLink
